import React from 'react'
import { ResultBorrowingContainer } from '../../containers/borrowSystem/ResultBorrowingContainer'
export const ResultBorrowingPage = () => {
    return (
        <ResultBorrowingContainer />
    )
}
